export class SearchCriterias {
  limit: number;
  offest: number;
  order: [string, string][]; // [field, order]
}
